import { VALIDATION_SETUP_MARKER } from './constants.mjs';

export default function isSetup(node) {
  if (VALIDATION_SETUP_MARKER in node.dataset) {
    return true;
  }

  return false;
}
